import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Axios from 'axios'
Vue.prototype.axios = Axios
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {MethodGet,MethodPost} from './api/goback'
import '@/assets/common.css' /*引入公共样式*/
Vue.use(ElementUI);
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd)
// 引入阿里巴巴矢量图
import "./assets/iconfont/iconfont.css";
import "./assets/common.css";


import Utils from "./assets/utils.js";
Vue.prototype.utils=Utils
//滚动条样式
import "@/assets/scrollbar.css"

// 二维码
// import QRCode from 'qrcodejs2'
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
Vue.prototype.MethodGet=MethodGet
Vue.prototype.MethodPost=MethodPost
import less from 'less'
Vue.use(less)
import jvuewheel from '@jyeontu/jvuewheel'

//引入样式
import '@jyeontu/jvuewheel/lib/jvuewhell.css'
Vue.use(jvuewheel);
import trim from './request/trim.js'
Vue.use(trim);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
